// Partieende im Spielmodus: Matt, Patt, zu wenig Material, 50-Züge-Regel, dreimalige Wiederholung.
import type { Chess } from 'chessops/chess';
import { t } from './i18n';
import type { PgnResult } from './playpgn';

export interface Ending {
  text: string;
  outcome: PgnResult;
}

/** repetitions = wie oft die aktuelle Stellung schon auf dem Brett stand */
export function ending(pos: Chess, me: 'white' | 'black', repetitions: number): Ending | null {
  if (pos.isCheckmate()) {
    const winner = pos.turn === 'white' ? 'black' : 'white';
    return { text: winner === me ? t('Matt. Du gewinnst.') : t('Matt. Stockfish gewinnt.'), outcome: winner === 'white' ? '1-0' : '0-1' };
  }
  const draw = pos.isStalemate() ? t('Patt. Remis.')
    : pos.isInsufficientMaterial() ? t('Zu wenig Material. Remis.')
    : pos.halfmoves >= 100 ? t('50-Züge-Regel. Remis.')
    : repetitions >= 3 ? t('Dreimalige Wiederholung. Remis.')
    : null;
  return draw ? { text: draw, outcome: '1/2-1/2' } : null;
}
